const supplierProductFields = `
      supplierId
      product (productId: $productId, ratePackage: $ratePackage) {
        _id
        productType
        ratePackageIndex
        productId
        productName
        ratePackageName
        bedsAndSofas {
          isApartment
          rooms {
            count
            bedType
            other
          }
        }
        seasons {
          _id
          seasonName
          dateRanges {
            eventName
            seasonStartDate
            seasonEndDate
          }
        }
        extras {
          _id
          extraType
          extraCode
          description
          taxInclusion
          currency
          taxType
          nonStandardTemplateType
          commissionPercentage
          nettCommission
          rateType
          rates { ...rateFragment }
        }
        offers (hideOffers: $hideOffers) {
          _id
          rates { ...rateFragment }
          offerName
          bookingCode
          offerDetail
          specialConditions
          allowCombination
          offerType
          numberOfGuests
          rate
          discountType
          amount
          nonStandardTemplateType
          commissionPercentage
          nettCommission
          rateType
          validDatesOfSale {
            fromDate
            toDate
          }
          validDatesOfTravel {
            fromDate
            toDate
          }
          isStayPay
          stayPays {
            stayDays
            payDays
            maxFOC
          }
          daysOfWeek
        }
        allocation (hideAllocation: $hideAllocation) {
          dateRanges { ...seasonDatesFragment }
          allocationType
          releaseBackDays
          numberOfRooms
          allotments {
            releaseBackDays
            numberOfRooms
          }
        }
        blackouts {
          name
          startDate
          endDate
        }
        pickup { ...pickupDropoff }
        dropoff { ...pickupDropoff }
        productPolicy (hideCancellation: $hideCancellation) {
          policyType
          ageFrom
          ageTo
          adultCount
          childrenCount
          focChildrenCount
          infantAsOccupant
          conditions
          cancellations {
            dateRanges { ...seasonDatesFragment }
            conditions
            cancelNum
            cancelHoursDays
            additionalRules {
              cancelNum
              cancelHoursDays
              arrivalDeparture
              cancelFee
              feeDollarPercent
              feeBase
            }
          }
        }
        seasonRates {
          _id
          seasonName
          dateRanges { ...seasonDatesFragment }
          rateSets {
            ratePackageName
            rates { ...rateFragment },
            rateSetName
            rateSetCode
            daysOfWeek
            commissionPercentage
            nettCommission
            includedGuestsinBaseRate
            rateType
            minStay
            maxStay
            taxInclusion
            currency
            taxType
            nonStandardTemplateType
          }
        }
      }
    }
  }
  fragment pickupDropoff on pickupDropoffType {
    dateRanges { ...seasonDatesFragment }
    time
    location
    notes
    timeLocArray {
      time
      location
    }
  }
  fragment seasonDatesFragment on seasonDateRangesType {
    eventName
    seasonStartDate
    seasonEndDate
  }
  fragment rateFragment on ratesType {
    priceCode
    notApplicable
    description
    minGuests
    maxAdults
    maxAdultsPlusChild
    retailRate (hideRates: $hideRates)
    nettRate (hideRates: $hideRates)
    extraAdult
    extraChild
  }
`;
const contractDetailsQuery = `
      contractId
      supplierId
      supplierProfileImageUrl
      supplierName
      locationId
      locationName
      propertyName
      productType
      supplierInfo {
        termsAndConditions
        submissionCriteria
        marketInfo
      }
      checkIn
      checkOut
      earlyCheckIn
      earlyCheckInCostType
      earlyCheckInFee
      earlyCheckInPercentageType
      lateCheckOut
      lateCheckOutFee
      lateCheckOutCostType
      lateCheckOutPercentageType
      locationPolicy (hideCancellation: $hideCancellation) {
        policyType
        conditions
        cancelNum
        cancelHoursDays
        additionalRules {
          cancelNum
          cancelHoursDays
          arrivalDeparture
          cancelFee
          feeDollarPercent
          feeBase
        }
        ageFrom
        ageTo
        adultCount
        childrenCount
        focChildrenCount
        infantAsOccupant
      }
      billingInformation {
        terms
        financialInstitution
        branch
        accountName
        accountNumber
        bsbRoutingNumber
        ibanSwiftCode
        currency
        insuranceExpirationYear
        insuranceExpirationMonth
        insuranceFiles {
          fileName
          downloadUrl
          hash
        }
      }
    }
  }`;
const leftNavFields = `
      contractId
      templateId
      isLatest
      supplierId
      supplierProfileImageUrl
      locationId
      locationName
      startDate
      endDate
      supplierEditable
      contractState
      supplierInfo {
        termsAndConditions
        submissionCriteria
        marketInfo
      }
      productsArray {
        _id
        ratePackageIndex
        productId
        productName
        ratePackageName
        productType
      }
    }
  }
`;

export const getMoreContractInfoForContractList = `
  query getContract ($contractId: ID!, $viewerId: ID!, $viewBy: String!) {
    Contract (id: $contractId, viewerId: $viewerId, viewBy: $viewBy) {
      partners {
        id
        name
        avatar
        tags {
          id
          name
        }
        contacts {
          firstName
          lastName
          email
          id
        }
      }
      contacts {
        id
        firstName
        lastName
        email
      }
      from {
        avatar
        name
        email
      }
      to {
        avatar
        name
        partnerId
        contactIds
      }
      toEmails
      supplierInfo {
        termsAndConditions
        submissionCriteria
        marketInfo
      }
      hasNewComments
    }
  }
`;
export const getContractDetailsQuery = `
  query getContract ($contractId: ID!, $viewerId: ID, $viewBy: String!, $email: String, $realActorEmail: String,
    $hideCancellation: Boolean) {
    Contract (id: $contractId, viewerId: $viewerId, viewBy: $viewBy, email: $email) {
      buyerName
      email
      startDate
      endDate
      buyerId
      buyerProfileImageUrl
      buyerInfo {
        termsAndConditions
        submissionCriteria
        corporateIdentificationNumber
      }
      buyerChecked
      files {
        _id
        name
        path
        createdAt
        source
        category
      }
      deadlineDate
      createdAt
      shouldSendReminders
      rateConversionSetting
      rateConversionStatus
      priority
      assignee {
        userId
        name
        email
      }
      partners {
        id
        name
        avatar
        tags {
          id
          name
        }
        contacts {
          firstName
          lastName
          email
          id
        }
      }
      contacts {
        id
        firstName
        lastName
        email
      }
      from {
        avatar
        name
        email
      }
      to {
        avatar
        name
        partnerId
        contactIds
      }
      toEmails
      dummySupplierForCR {
         accountId
         productType
         oneOrMulti
         locations {
            locationId
            name
            products {
               productId
               productType
               name
            }
         }
         templates (realActorEmail: $realActorEmail) {
            _id
            threadId
            originalContractId
            templateName
            status
            magicLink
            magicLinkForDiffing
            buyerCreatedFrom
            startDate
            endDate
            locationName
            createdAt
            updatedAt
            completionPercent
            templateVersions
            originFrom
            activities {
               actor
               action
               createdAt
            }
            acceptedBy
         }
      }
      ${contractDetailsQuery}
`;

export const draftTemplateContractDetails = `
  query getContract ($contractId: ID!, $collection: String!, $viewerId: ID!, $viewBy: String!,
    $hideCancellation: Boolean, $viewOnly: Boolean) {
    DraftnTemplate (id: $contractId, collection: $collection, viewerId: $viewerId, viewBy: $viewBy, viewOnly: $viewOnly) {
      draftId
      policyNotesTemplateId
      policyNotesTemplateName
      sameAsCorporatePolicyNotes
      ${contractDetailsQuery}
`;

export const getLeftNavQuery = `
  query getContract ($contractId: ID!, $viewerId: ID!, $realActorEmail: String, $viewBy: String!) {
    Contract (id: $contractId, viewerId: $viewerId, viewBy: $viewBy) {
      lastSent
      buyerId
      buyerProfileImageUrl
      buyerName
      companyName
      email
      forGroupQuote
      rateContainer {
        id
        year
        partnerName
      }
      rateConversionSetting
      rateConversionStatus
      priority
      assignee {
        userId
        name
        email
      }
      signatures {
        signatureText
        signedBy
        signedAt
      }
      templateFromDummy
      templateHasDraft
      buyerHasDraftId
      buyerCreatedFrom
      buyerInfo {
        termsAndConditions
        submissionCriteria
        corporateIdentificationNumber
      }
      state
      buyerHasNewComments
      supplierHasNewComments
      oldContractId
      buyerDownloaded
      productType
      amended
      amendedFrom
      amendmentInfo {
        amendedFromId
        isInitialAmendmentDraft
        amended
        amendmentId
      }
      respondedContracts
      hasDraft
      draftMagicLink (realActorEmail: $realActorEmail)
      buyerChecked
      supplierChecked
      emailStatus
      versions
      allVersions
      buyerChecked
      files {
        _id
        name
        path
        createdAt
        source
      }
      privateDomain
      domain
      historyFeedId
      senderCompanyId
      viewedBy
      isViewed
      isSender
      isRequest
      viewingAs
      partners {
        id
        name
        avatar
        tags {
          id
          name
        }
        contacts {
          firstName
          lastName
          email
          id
        }
      }
      contacts {
        id
        firstName
        lastName
        email
      }
      from {
        avatar
        name
        email
      }
      to {
        avatar
        name
        partnerId
        contactIds
      }
      toEmails
      hasNewComments
      ${leftNavFields}
`;
export const draftTemplateLeftNav = `
  query getContract ($contractId: ID!, $collection: String!, $viewerId: ID!, $viewBy: String!, $realActorEmail: String, $email: String, $hideRates: Boolean, $viewOnly: Boolean) {
    DraftnTemplate (id: $contractId, collection: $collection, viewerId: $viewerId, viewBy: $viewBy, viewOnly: $viewOnly) {
      originFrom
      draftId
      originalContractId
      productType
      templateName
      templateHasDraft
      defaultInvitees
      signatures {
         invitee
         inviteSentAt
         inviteSentBy
      }
      acceptedBy
      draftType
      threadId
      state
      supplierName
      hasSeenResponseWizard
      templateVersions
      allTemplateVersions
      allContractingReadyProducts {
        productId
        productName
        productType
        bedsAndSofasComplete
        bedsAndSofas {
          isApartment
          rooms {
            count
            bedType
            other
          }
        }
        added
      }
      partnersCount
      sentPartners {
        _id
        from {
          avatar
          name
          email
        }
        to {
          avatar
          name
          partnerId
          contactIds
        }
        toEmails
        locationId
        email
        companyName
        locationName
        state
        versions
        startDate
        endDate
        updatedAt
      }
      stagedUpdates {
        source
        sourceId
        message
      }
      templates (realActorEmail: $realActorEmail, accountUserEmail: $email) {
        _id
        templateName
        startDate
        endDate
        locationId
        createdAt
      }
      editHistory {
        detail
        productId
        ratePackageName
      }
      syncedSections
      createdAt
      productSharedData {
        allExtras {
          _id
          extraType
          extraCode
          description
          taxInclusion
          currency
          taxType
          nonStandardTemplateType
          commissionPercentage
          nettCommission
          rateType
          rates { ...rateFragment }
          ratePackages
        }
        allOffers {
          _id
          rates { ...rateFragment }
          offerName
          bookingCode
          offerDetail
          specialConditions
          allowCombination
          offerType
          numberOfGuests
          rate
          discountType
          amount
          nonStandardTemplateType
          commissionPercentage
          nettCommission
          rateType
          validDatesOfSale {
            fromDate
            toDate
          }
          validDatesOfTravel {
            fromDate
            toDate
          }
          isStayPay
          stayPays {
            stayDays
            payDays
            maxFOC
          }
          daysOfWeek
          ratePackages
        }
      }
      ${leftNavFields}
  fragment rateFragment on ratesType {
    priceCode
    notApplicable
    description
    minGuests
    maxAdults
    maxAdultsPlusChild
    retailRate (hideRates: $hideRates)
    nettRate (hideRates: $hideRates)
    extraAdult
    extraChild
  }
`;
export const getProductDetailsQuery = `
  query getProduct(
    $contractId: ID!,
    $productId: ID!,
    $viewerId: ID!,
    $viewBy: String!,
    $ratePackage: String,
    $hideRates: Boolean,
    $hideCancellation: Boolean,
    $hideOffers: Boolean,
    $hideAllocation: Boolean,
    ) {
    Contract (id: $contractId, viewerId: $viewerId, viewBy: $viewBy) {
      buyerId
      ${supplierProductFields}`;

export const draftTemplateProductQuery = `
  query getProduct(
    $contractId: ID!,
    $collection: String!,
    $productId: ID!,
    $viewerId: ID!,
    $viewBy: String!,
    $ratePackage: String,
    $hideRates: Boolean,
    $hideCancellation: Boolean,
    $hideOffers: Boolean,
    $hideAllocation: Boolean,
    $viewOnly: Boolean,
    ) {
    DraftnTemplate (id: $contractId, collection: $collection, viewerId: $viewerId, viewBy: $viewBy, viewOnly: $viewOnly) {
    draftId
    productType
    formData (productId: $productId){
      currency
      rateType
      taxType
      taxInclusion
      commissionPercentage
      nettCommission
      includedGuestsinBaseRate
      maxAdultsChildren
      maxAdults
      additionalAdult
      additionalAdultRetail
      additionalChild
      additionalChildRetail
      paxMax
      twinBedsAvail
    }
    ${supplierProductFields}`;



// WEBPACK FOOTER //
// ./src/app/stores/contracting/contract-activities-products/graphql-queries.js